// src/components/SocialLinks.tsx
import { Linkedin, Github, Mail, ExternalLink } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SocialLinksProps {
  className?: string;
  iconSize?: number;
  vertical?: boolean;
}

const SocialLinks = ({ 
  className, 
  iconSize = 20,
  vertical = false 
}: SocialLinksProps) => {
  return (
    <div className={cn(
      'flex items-center gap-4', 
      vertical ? 'flex-col' : 'flex-row',
      className
    )}>
      <a 
        href="https://in.linkedin.com/in/priya-pareek-priyartist" 
        target="_blank" 
        rel="noreferrer" 
        aria-label="LinkedIn"
        className="text-muted-foreground hover:text-foreground transition-colors duration-300"
      >
        <Linkedin size={iconSize} />
      </a>
      <a 
        href="mailto:contact@priyapareek.com" 
        aria-label="Email"
        className="text-muted-foreground hover:text-foreground transition-colors duration-300"
      >
        <Mail size={iconSize} />
      </a>
      <a 
        href="https://github.com/priyapareek" 
        target="_blank" 
        rel="noreferrer"
        aria-label="GitHub" 
        className="text-muted-foreground hover:text-foreground transition-colors duration-300"
      >
        <Github size={iconSize} />
      </a>
      <a 
        href="https://priyapareek.com" 
        target="_blank" 
        rel="noreferrer" 
        aria-label="Portfolio"
        className="text-muted-foreground hover:text-foreground transition-colors duration-300"
      >
        <ExternalLink size={iconSize} />
      </a>
    </div>
  );
};

export default SocialLinks;